import styled from "styled-components";

import { FaTimes, FaUser, FaHome, FaChartLine, FaChartPie, FaCreditCard, FaEye, FaEyeSlash, FaTrashAlt } from 'react-icons/fa';

export const GraphComponentContainer = styled.div`
 width: auto;
 height: '1000px';
 display: 'flex';
 flexDirection: 'column',
 overflow: 'scroll';
 margin-top: 20px;
`;

export const ButtonHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  margin-bottom: 20px;
  
 @media screen and (min-width: 490px){
      background: black;
      height: 26px;
      border-radius: 50px;
      width: fit-content;
      display: flex;
      margin-left: auto;
      padding: 12px;
  }

`;

export const FormH1 = styled.h1`
  color: #cc8f2d;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  align-self: start;
`;


export const RemoveWLButton = styled(FaTrashAlt)`
  display: flex;
  font-size: 1.0rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #fff;
  cursor: pointer;
  margin-right: 12px;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const CloseComponentButton = styled(FaTimes)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const StyledIconSlashButton = styled(FaEyeSlash)`
 margin: 14px;
 color: #fff;

 
  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const StyledIconButton = styled(FaEye)`
 margin: 14px;
 color: #fff;

 
  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const InputItemContainer = styled.div`
  color: white;
  margin-right: 20px;
  justify-content: right;
  display: flex;
  flex-direction: row;
`

export const CheckboxContainer = styled.div`
  color: white;
  justify-content: right;
  display: flex;
  flex-direction: row;
`;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // width: 20px;
  // height: 20px;
  border: 2px solid #cc8f2d;
  margin-left: 8px;
  margin-right: 12px;
  position: relative;
  accent-color: #cc8f2d;
  transition: background-color 0.3s ease;
  // background-color: ${({ checked }) => (checked ? 'white' : 'cc8f2d')};
`;

export const RegularText = styled.div`
  margin-right: 20px;
  font-size: 16px;
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #0b0e11;
  color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  max-width: 900px;
  margin: 20px auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// Left Column: Stock Details
export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #23282d;
  padding-right: 32px;

  @media (max-width: 768px) {
    border-right: none;
    padding-right: 0;
    border-bottom: 1px solid #23282d;
    padding-bottom: 24px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StockHeader = styled.div`
  margin-bottom: 20px;
`;

export const StockSymbol = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

export const StockName = styled.p`
  margin: 4px 0 0 0;
  color: #848e9c;
  font-size: 1rem;
`;


export const ToggleWrapper = styled.div`
  margin-top: 10px;
  right: 10px;
  display: flex;
  align-items: top;
  gap: 6px;
  font-family: sans-serif;
  font-size: 11px;
  font-weight: bold;
  user-select: none;
  
  @media (max-width: 768px) {
    gap: 3px;
  }
`;


export const Option = styled.span`
  cursor: pointer;
  color: ${({ isActive }) => isActive ? '#ffffff' : '#888888'};
  transition: color 0.2s ease;

  &:hover {
  color: #ffffff;
  }
`;

export const Divider = styled.span`
  color: #888888;
  margin-left: 3px;
  margin-right: 3px;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 24px;
`;

export const CurrentPrice = styled.div`
  font-size: 2.5rem;
  font-weight: 600;
  margin-right: 12px;
`;

export const PriceChange = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: ${props => (props.isPositive ? '#0ecb81' : '#f6465d')};
`;

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DataLabel = styled.span`
  font-size: 0.85rem;
  color: #848e9c;
  margin-bottom: 4px;
`;

export const DataValue = styled.span`
  font-size: 1rem;
  font-weight: 500;
`;


export const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;


export const RightHeaderContainer = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 20px 0;
  font-size: 1.2rem;
  font-weight: 600;
  justify-self: start;
`;

export const ActionToggleGroup = styled.div`
  display: flex;
  background-color: #1e2329;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 20px;
`;

export const ToggleButton = styled.button`
  flex: 1;
  // background: ${props => (props.active ? (props.action === 'buy' ? '#0ecb81' : '#f6465d') : 'transparent')};
  background: ${props => (props.active ? (props.action === 'buy' ? '#cc8f2d' : '#cc8f2d') : 'transparent')};
  color: ${props => (props.active ? '#ffffff' : '#848e9c')};
  border: none;
  border-radius: 6px;
  padding: 10px 0;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #ffffff;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const InputLabel = styled.label`
  font-size: 0.85rem;
  color: #848e9c;
  margin-bottom: 6px;
`;

export const StyledInput = styled.input`
  background-color: #1e2329;
  border: 1px solid #32383e;
  border-radius: 8px;
  color: #ffffff;
  padding: 12px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #f0b90b; /* Binance gold style accent */
  }

  &::placeholder {
    color: #474d57;
  }
`;

export const SubmitButton = styled.button`
  background-color: ${props => (props.action === 'buy' ? '#0ecb81' : '#f6465d')};
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 12px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;